"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildAttributes = buildAttributes;
exports.Contains = Contains;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/*

 {%- macro buildAttributes(attributes) -%}
 {%- set attributesPack = "" -%}
 {%- if attributes is iterable -%}
 {%- for key, value in attributes -%}
 {%- set attributesPack = attributesPack ~ key ~ '="' ~ value|raw ~ '" ' -%}
 {%- endfor -%}
 {%- endif -%}
 {% if attributesPack is not empty %} {{ attributesPack|slice(0,(attributesPack|length -1))|raw }} {% endif %}
 {%- endmacro -%}


* */
function buildAttributes(attrib, props, baseClass) {
  var att = _objectSpread({}, attrib);

  if (att.className == undefined) {
    att.className = baseClass;
  } else {
    att.className += " " + baseClass;
  }

  if (att["class"]) {
    att.className += " " + att["class"];
    delete att['class'];
  }

  if (props.className) {
    att.className += " " + props.className;
  }

  var inlineStyle = props.style ? props.style : {};
  att.style = Object.assign(inlineStyle, att.style);
  att.className = att.className.trim();
  return att;
}
/*
param :
    element -> source node
    target -> event.target node
 */


function Contains(element, target) {
  if (element && element.contains(target)) {
    return true;
  }

  return false;
}
/*
export function Closest(target,closestTo) {

    if (window.Element && !Element.prototype.closest) {
        Element.prototype.closest =
            function(s) {
                var matches = (this.document || this.ownerDocument).querySelectorAll(s),
                    i,
                    el = this;
                do {
                    i = matches.length;
                    while (--i >= 0 && matches.item(i) !== el) {};
                } while ((i < 0) && (el = el.parentElement));
                return el;
            };
        console.log('polyfill');
    } else {
        console.log('normal');
        return target.closest(closestTo);
    }
}

    */